module.exports = __webpack_public_path__ + "static/img/h5_open_app.82daa2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/h5_open_app.png
// module id = hQbw
// module chunks = 1